export interface GraphChangeObservation {
  branchKey: string
  token: string
}

export function graphChangeTokenMoved(
  previous: GraphChangeObservation | undefined,
  next: GraphChangeObservation
): boolean {
  return (
    previous !== undefined && previous.branchKey === next.branchKey && previous.token !== next.token
  )
}
